@if (members && members.length) {
  <div class="flex items-end" *ngIf="members && members.length">
    <ng-container *ngFor="let member of members; let i = index">
      <div
        *ngIf="members.length > MAX && i === MAX"
        class="relative z-0 text-white -ml-2"
      >
        <div
          class="w-8 h-8 rounded-full border-2 border-white bg-gray-500 flex justify-center items-center text-xs"
        >
          +{{ members.length - 2 }}
        </div>
      </div>

      <div *ngIf="members && (members.length <= MAX || i < 2)">
        <img
          *ngIf="member.image; else noImageTemplate"
          [src]="member.image"
          alt="{{ member.name }}"
          [appTooltip]="member.name"
          class="rounded-full border-1 border-white z-10 {{ config.size }}"
          [style.margin-left]="i !== 0 ? '12px' : '0'"
          [style.margin-bottom]="i !== 0 ? '-30px' : '0'"
        />
        <ng-template #noImageTemplate>
          <div
            [appTooltip]="member.name"
            [style.background-color]="member.bgColor"
            [ngClass]="[
              'rounded-full',
              'flex',
              'justify-center',
              'items-center',
              'border-1',
              'border-white',
              'text-white',
              'text-md',
              config.size ?? 'defaultSize'
            ]"
            [style.margin-left]="i !== 0 ? '-6px' : '0'"
            [style.margin-bottom]="i !== 0 ? '0' : '0'"
          >
            {{ getInitials(member.name) }}
          </div>
        </ng-template>
      </div>
    </ng-container>
  </div>
}
